import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']

})
export class ConfirmDialogComponent {
  public constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message?: string, title?: string, confirmButton?: string, colorConfirmButton?: string }
  ) {
    this.data.colorConfirmButton = this.data.colorConfirmButton || 'primary';
    this.data.title = this.data.title || 'Atenção';
    this.data.confirmButton = this.data.confirmButton || 'Sim';
    this.data.message = this.data.message || 'Você tem certeza que deseja continuar?';
  }

  public onConfirm(): void {
    this.dialogRef.close(true);
  }

  public onCancel(): void {
    this.dialogRef.close(false);
  }
}